export default function ProfileInfo({ user }) {
  if (!user) {
    return <div className="profile-card">Loading...</div>;
  }

  return (
    <div className="profile-info-wrapper">

      {/* ===== BASIC INFO CARD ===== */}
      <div className="profile-card">
        <h3>Basic Information</h3>

        <div className="info-row">
          <span>Full Name</span>
          <strong>{user.fullName || "-"}</strong>
        </div>

        <div className="info-row">
          <span>Nick Name</span>
          <strong>@{user.nickName || "-"}</strong>
        </div>

        <div className="info-row">
          <span>Email</span>
          <strong>{user.email || "-"}</strong>
        </div>

        <div className="info-row">
          <span>Mobile</span>
          <strong>{user.mobileNumber || "-"}</strong>
        </div>

        <div className="info-row">
          <span>Country</span>
          <strong>{user.country || "-"}</strong>
        </div>

        <div className="info-row">
          <span>Gender</span>
          <strong>{user.gender || "-"}</strong>
        </div>

        <div className="info-row">
          <span>Age</span>
          <strong>{user.age || "-"}</strong>
        </div>
      </div>

      {/* ===== CHANNEL INFO ===== */}
      <div className="profile-card">
        <h3>Channel Information</h3>

        <div className="info-row">
          <span>Description</span>
          <strong>
            {user.descriptionOfChannel || "No description added."}
          </strong>
        </div>

        <div className="info-row">
          <span>Channel Type</span>
          <strong>
            {user.channelType === 1 ? "Public" : "Private"}
          </strong>
        </div>

        <div className="info-row">
          <span>Subscription Cost</span>
          <strong>{user.subscriptionCost || 0} Coins</strong>
        </div>

        <div className="info-row">
          <span>Video Unlock Cost</span>
          <strong>{user.videoUnlockCost || 0} Coins</strong>
        </div>
      </div>

      {/* ===== MONETIZATION INFO ===== */}
      <div className="profile-card">
        <h3>Monetization & Plan</h3>

        <div className="info-row">
          <span>Monetization</span>
          <strong
            className={
              user.isMonetization
                ? "status-active"
                : "status-inactive"
            }
          >
            {user.isMonetization ? "Enabled" : "Disabled"}
          </strong>
        </div>

        <div className="info-row">
          <span>Premium Plan</span>
          <strong>
            {user.plan?.premiumPlanId
              ? "Active Plan"
              : "No Active Plan"}
          </strong>
        </div>
      </div>

      {/* ===== SOCIAL LINKS ===== */}
      <div className="profile-card">
        <h3>Social Links</h3>

        <div className="social-links">
          {user.socialMediaLinks?.instagramLink && (
            <a
              href={user.socialMediaLinks.instagramLink}
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
          )}

          {user.socialMediaLinks?.facebookLink && (
            <a
              href={user.socialMediaLinks.facebookLink}
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>
          )}

          {user.socialMediaLinks?.twitterLink && (
            <a
              href={user.socialMediaLinks.twitterLink}
              target="_blank"
              rel="noreferrer"
            >
              Twitter
            </a>
          )}

          {user.socialMediaLinks?.websiteLink && (
            <a
              href={user.socialMediaLinks.websiteLink}
              target="_blank"
              rel="noreferrer"
            >
              Website
            </a>
          )}
        </div>
      </div>

    </div>
  );
}
